import React from 'react';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import '../../App.css';
import setSearchContestReleaseAction from '../../redux/actions/searchReferenceActions/actionSearchContestRelease';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

class SearchContest extends React.Component {

    constructor(props) {
        super(props);

        this.handleChangeSwitch = this.handleChangeSwitch.bind(this);

        if(this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
            this.state = {checked: JSON.parse(this.props.selectedReferenceData.contestRelease.toLowerCase()), contestRelease: true}
            this.props.setContestReleaseFunktion(JSON.parse(this.props.selectedReferenceData.contestRelease.toLowerCase()))
        } else {
            this.state = {checked: false, contestRelease: false}
            this.props.setContestReleaseFunktion('false')
        }
    }
        // Switch handler
        handleChangeSwitch = (event) => {
            // true/false
            this.setState({ [event.target.name]: event.target.checked, contestRelease: event.target.checked  }, () => {
                this.props.setContestReleaseFunktion(this.state.contestRelease);
            });
        }

    render() {

        const { t } = this.props;

        return (
            <Button style={{ width: 300, backgroundColor: 'rgba(19, 174, 236, 0.54)', marginBottom: '10px' }} variant="contained" color="primary" size="large">
                {t("create_ref.photo_contest")}
                <Switch color="secondary" checked={this.state.checked} onChange={this.handleChangeSwitch} name="checked" />
            </Button>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setContestReleaseFunktion: searchContestRelease => {
            dispatch(setSearchContestReleaseAction(searchContestRelease));
        }
    }
}
// const mapStateToProps = state => {

//     return {
//         selectedReferenceData: state.showRefState.selectedReferenceData
//     }
// }

export default connect(null, mapDispatchToProps)(withTranslation()(SearchContest)); 